import { handleActions } from "redux-actions";
import { LSID_IDENTITY_SET, LSID_IDENTITY_UPDATE } from "constants/action-types";

interface IState {
    userGrants: IGrants;
    accountGrants: IGrants;
    features: Array<string>;
    accountFeatures: IAccountFeature;
    token: string;
}

interface IAccountFeature {
    [accountId: string]: Array<string>;
}

interface IGrants {
    [productName: string]: Array<string>;
}

const initialState: IState = {
    userGrants: {},
    accountGrants: {},
    features: [],
    accountFeatures: {},
    token: "",
};

export const lsid = handleActions(
    {
        [LSID_IDENTITY_SET]: (state: IState, { payload }: any): IState => {
            return {
                ...state,
                userGrants: payload.userGrants,
                accountGrants: payload.accountGrants,
                features: payload.features,
                accountFeatures: payload.accountFeatures,
                token: payload.lsidToken,
            };
        },
        [LSID_IDENTITY_UPDATE]: (state: IState, { payload }: any): IState => {
            return {
                ...state,
                userGrants: payload.userGrants,
                accountGrants: payload.accountGrants,
                features: payload.features,
                accountFeatures: payload.accountFeatures,
            };
        },
    },
    initialState
);
